import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, createVNode as _createVNode, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5935214c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nan-modal-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "NaN value detected!")
], -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons nan-modal-discord" }, "discord", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "nan-footer" }

import Modal from "components/Modal.vue";
import projInfo from "data/projInfo.json";
import player from "game/player";
import state from "game/state";
import Decimal, { DecimalSource, format } from "util/bignum";
import { ComponentPublicInstance, computed, ref, toRef } from "vue";
import Toggle from "./fields/Toggle.vue";
import SavesManager from "./SavesManager.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { discordName, discordLink } = projInfo;
const autosave = toRef(player, "autosave");
const hasNaN = toRef(state, "hasNaN");
const savesManager = ref<ComponentPublicInstance<typeof SavesManager> | null>(null);

const path = computed(() => state.NaNPath?.join("."));
const property = computed(() => state.NaNPath?.slice(-1)[0]);
const previous = computed<DecimalSource | null>(() => {
    if (state.NaNReceiver && property.value) {
        return state.NaNReceiver[property.value] as DecimalSource;
    }
    return null;
});
const isPaused = computed({
    get() {
        return player.devSpeed === 0;
    },
    set(value: boolean) {
        player.devSpeed = value ? null : 0;
    }
});

function setZero() {
    if (state.NaNReceiver && property.value) {
        state.NaNReceiver[property.value] = new Decimal(0);
        state.hasNaN = false;
    }
}

function setOne() {
    if (state.NaNReceiver && property.value) {
        state.NaNReceiver[property.value] = new Decimal(1);
        state.hasNaN = false;
    }
}

function ignore() {
    if (state.NaNReceiver && property.value) {
        state.NaNReceiver[property.value] = new Decimal(NaN);
        state.hasNaN = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Modal, _mergeProps({
      modelValue: _unref(hasNaN),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(hasNaN) ? (hasNaN).value = $event : null))
    }, _ctx.$attrs), {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", null, [
          _createTextVNode(" Attempted to assign \"" + _toDisplayString(_unref(path)) + "\" to NaN", 1),
          (_unref(previous))
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(" ") + "(previously " + _toDisplayString(_unref(format)(_unref(previous))) + ")", 1))
            : _createCommentVNode("", true),
          _createTextVNode(". Auto-saving has been " + _toDisplayString(_unref(autosave) ? "enabled" : "disabled") + ". Check the console for more details, and consider sharing it with the developers on discord. ", 1)
        ]),
        _hoisted_3,
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            href: _unref(discordLink),
            class: "nan-modal-discord-link"
          }, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_unref(discordName)), 1)
          ], 8, _hoisted_4)
        ]),
        _hoisted_6,
        _createVNode(Toggle, {
          title: "Autosave",
          modelValue: _unref(autosave),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(autosave) ? (autosave).value = $event : null))
        }, null, 8, ["modelValue"]),
        (_unref(projInfo).enablePausing)
          ? (_openBlock(), _createBlock(Toggle, {
              key: 0,
              title: "Pause game",
              modelValue: _unref(isPaused),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isPaused) ? (isPaused).value = $event : null))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (savesManager.value?.open())),
            class: "button"
          }, "Open Saves Manager"),
          _createElementVNode("button", {
            onClick: setZero,
            class: "button"
          }, "Set to 0"),
          _createElementVNode("button", {
            onClick: setOne,
            class: "button"
          }, "Set to 1"),
          (_unref(previous) && _unref(Decimal).neq(_unref(previous), 0) && _unref(Decimal).neq(_unref(previous), 1))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (hasNaN.value = false)),
                class: "button"
              }, " Set to previous "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: ignore,
            class: "button danger"
          }, "Ignore")
        ])
      ]),
      _: 1
    }, 16, ["modelValue"]),
    _createVNode(SavesManager, {
      ref_key: "savesManager",
      ref: savesManager
    }, null, 512)
  ], 64))
}
}

})